export default __webpack_public_path__ + "static/media/Logo-circle.8bc79b53.png";